import { IconProps } from "./";
import Icon from "./assets/hamburger_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Hamburger(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
